import React from "react";
import { motion } from "framer-motion";

/**
 * Marquee — an infinite-scrolling ribbon of items.
 * Pure CSS animation, paused on hover, no JS frames per second cost.
 *
 * @param {object} props
 * @param {React.ReactNode[]} props.items  The chip/icon/label elements to repeat
 * @param {string} [props.className]
 * @param {boolean} [props.reverse]
 * @param {number} [props.speed=40]  Seconds for one full loop
 */
export default function Marquee({ items = [], className = "", reverse = false, speed = 40 }) {
  const doubled = [...items, ...items];
  return (
    <div
      className={`relative overflow-hidden w-full ${className}`}
      style={{
        maskImage:
          "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
        WebkitMaskImage:
          "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
      }}
      data-testid="marquee"
    >
      <div
        className="flex gap-12 w-max"
        style={{
          animation: `marquee ${speed}s linear infinite ${reverse ? "reverse" : ""}`,
        }}
      >
        {doubled.map((node, i) => (
          <div key={i} className="shrink-0 flex items-center">
            {node}
          </div>
        ))}
      </div>
    </div>
  );
}
